import React,{ useState, useEffect, useRef } from 'react';
import { Drawer, Col, Row } from 'antd';
import { CloseOutlined  } from '@ant-design/icons';

import BaseButton from '../../components/BaseButton/BaseButton'
import CardDom from '../CardDom/CardDom';

import './ProductDescription.less'


const ProductDescription = ({productDescriptionData}) =>{
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  return (
    <div className="productDescription-box">
      <div className={width > 770? "productDescription":"productDescription-phone"}>
        {productDescriptionData.title}  
      </div>

      {width > 770? 
        <BaseButton 
          style={{cursor: 'pointer'}}
          btnConfig={{
            text: '探索我们的科学',
            icon: 'ArrowRightOutlined',
            link: '/science'
          }}
        />
        :
        ''
      }
      

      <Row justify="space-between" gutter={16}>
        {productDescriptionData.data.map((e,i)=>{
          return (
            <Col key={i} span={width > 770? 6:12}>
              <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
            </Col>
          )
        })}
      </Row>

      {width > 770? 
        ''
        :
        <BaseButton 
          style={{width:'100%', cursor: 'pointer'}}
          btnConfig={{
            text: '探索我们的科学',
            icon: 'ArrowRightOutlined',
            link: '/science'
          }}
        />
      }
    </div>
  )
}

export default ProductDescription